import React, { useEffect, useState } from 'react'
import { handleDownload } from '../../utils/driverSchedule';
import { apiDriverApp } from '../../../../../libs/apiDriverApp';
import { Dropdown } from 'semantic-ui-react';
import IconFileExport from '../../../../icons/fileExport';
import moment from 'moment';
import IconFilterAlt from '../../../../icons/filterIconAlt';
import LoadMask from '../../../Utils/LoadMask';
import ManagedInOdooNotice from '../ManagedInOdooNotice';

export const DefaultScheduleView = () => {
    const [search, setSearch] = useState("");
    const [schedules, setSchedules] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState("all");

    const categoryOptions = [
        { key: "all", text: "All", value: "all" },
        { key: "unassigned ", text: "Unassigned ", value: "Unassigned" },
    ];

    const handleFilterChange = (event, { value }) => {
        setSelectedCategory(value);
    };

    const filteredSchedules = schedules && schedules.filter((schedule) => {
        const matchesCategory =
            selectedCategory === "Unassigned"
                ? schedule.drivers.length === 0
                : true;

        const matchesSearch =
            schedule.name.toLowerCase().includes(search.toLowerCase()) ||
            schedule.drivers.some((driver) =>
                driver.name.toLowerCase().includes(search.toLowerCase())
            );
        return matchesCategory && matchesSearch;
    });

    const getAllshcedules = async () => {
        setLoading(true)
        const actualDate = moment().format('YYYY-MM-DD')
        try {
            const { data } = await apiDriverApp.get(`api/hr/schedule/get_all_driver_schedules/?start_date=${actualDate}`);
            const sortedData = data.sort((a, b) => {
                if (a.drivers.length === 0 && b.drivers.length > 0) return 1;
                if (b.drivers.length === 0 && a.drivers.length > 0) return -1;
                return 0;
            });

            setSchedules(sortedData);
            setLoading(false)
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    };

    const weekDays = [
        { id: 0, name: 'Sat' },
        { id: 1, name: 'Sun' },
        { id: 2, name: 'Mon' },
        { id: 3, name: 'Tues' },
        { id: 4, name: 'Wed' },
        { id: 5, name: 'Thur' },
        { id: 6, name: 'Fri' },
    ]

    useEffect(() => {
        getAllshcedules()
    }, [])

    return (
        <React.Fragment>
            <ManagedInOdooNotice what="Schedules" />
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div className='d-flex align-items-center w-50'>
                    <div className="w-75">
                        <input
                            placeholder="Search..."
                            className="form-control"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>
                    <div className='px-0 justify-content-end align-items-center ml-2'>
                        <div className='justify-content-end'>
                            <Dropdown
                                options={categoryOptions}
                                onChange={handleFilterChange}
                                clearable
                                scrolling
                                className="custom-dropdown"
                                compact
                                icon={null}
                                trigger={
                                    <div style={{ display: 'flex', alignItems: 'center', height: '1.3rem' }}>
                                        <IconFilterAlt className="h-100" />
                                    </div>
                                }
                            />
                        </div>
                    </div>
                </div>

                <div className="d-flex align-items-center" style={{ gap: 15 }}>
                    <button
                        className="btn rounded shadow-sm d-flex flex-row align-items-center gap-2"
                        style={{ backgroundColor: '#DADADA' }}
                        onClick={handleDownload}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', height: '0.8rem' }}>
                            <IconFileExport className="h-100" />
                        </div>
                        <span style={{ fontWeight: 'bold', margin: 0, cursor: 'pointer', marginLeft: 5, backgroundColor: '#DADADA' }}>Export</span>
                    </button>
                </div>

            </div>
            <LoadMask loading={loading} blur>
                <div style={{
                    height: "700px",
                    overflowY: "auto",
                    overflowX: "hidden",
                }}>
                    <table className="table table-bordered" >
                        <thead className="bg-secondary text-white text-center">
                            <tr>
                                <th style={{ width: '35%' }}>Title</th>
                                <th style={{ width: '40%' }}>Pattern</th>
                                <th style={{ width: '25%' }}>Drivers</th>
                            </tr>
                        </thead>

                        <tbody>
                            {
                                filteredSchedules && filteredSchedules.length > 0 ? filteredSchedules.map((schedule, index) => (
                                    <tr key={index}>
                                        <td>
                                            {schedule.name}
                                        </td>
                                        <td className="flex-column">
                                            {
                                                schedule.weeks.map((week, index) => (
                                                    <div key={index}><strong>{`Week ${week.week_type + 1}: `}</strong>
                                                        {week.days.map((day) => {
                                                            const dayName = weekDays.find((d) => d.id === day.dayofweek).name || "Unknown";
                                                            return <span key={day.dayofweek}>{`${dayName}, `}</span>;
                                                        })}
                                                    </div>
                                                ))
                                            }
                                        </td>
                                        <td className="flex-column">
                                            {
                                                schedule.drivers.map((driver, index) => (
                                                    <div key={index}>{driver.name}</div>
                                                ))
                                            }
                                        </td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan="3" className="text-center align-middle">
                                            <div>No Data</div>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>


                    </table>

                </div>
            </LoadMask>

        </React.Fragment>
    )
}
